import React from 'react'
import ActivateAccountWidget from './active_account_widget'

function ActivateAccount() {
  return (
    <div>
        <ActivateAccountWidget/>
    </div>
  )
}

export default ActivateAccount